import { getCountryById } from './country.js'

export const formatDeliveryAddress = (shipment) => {
    if (!shipment) return ''
    const addr = shipment.address || shipment
    const lines = [
        addr.company || shipment.company,
        addr.street || shipment.street,
        addr.street_number || shipment.street_number,
        addr.additional_field_1 || shipment.additional_field_1,
        addr.additional_field_2 || shipment.additional_field_2,
        addr.zipcode || shipment.zipcode,
        addr.city || shipment.city,
        addr.county || shipment.county,
        addr.country?.name || shipment.country?.name || getCountryById(addr.country_id || shipment.country_id)?.name,
    ]
    return lines.filter(v => Boolean(v && String(v).trim())).join(', ')
}
